import { Menu, LogOut, Settings } from 'lucide-react';
import { useAuth } from '@lib/auth';
import { useUIStore } from '@stores/ui.store';
import { CHANGE_PASSWORD_MODAL_ID } from './ChangePasswordModal';
import { ThemeToggle } from '@components/ThemeToggle';

export function Header(): JSX.Element {
  const { logout } = useAuth();
  const { toggleSidebar, openModal } = useUIStore();

  const handleLogout = async (): Promise<void> => {
    await logout();
  };

  const handleOpenSettings = (): void => {
    openModal(CHANGE_PASSWORD_MODAL_ID);
  };

  return (
    <header className="h-16 glass flex items-center justify-between px-6">
      {/* Left side */}
      <div className="flex items-center gap-4">
        <button
          onClick={toggleSidebar}
          className="p-2.5 rounded-lg text-ybh-text-muted hover:bg-ybh-bg-tertiary hover:text-ybh-text-primary transition-colors duration-200"
          aria-label="Toggle sidebar"
        >
          <Menu size={20} />
        </button>

        {/* Breadcrumb / Page context could go here */}
      </div>

      {/* Right side */}
      <div className="flex items-center gap-3">
        {/* Theme toggle */}
        <ThemeToggle />

        {/* Settings button */}
        <button
          onClick={handleOpenSettings}
          className="group flex shrink-0 items-center gap-2 whitespace-nowrap px-3 py-2 rounded-lg text-ybh-text-muted hover:bg-ybh-bg-tertiary hover:text-ybh-text-primary transition-colors duration-200"
          aria-label="Settings"
          title="Change Password"
        >
          <Settings size={18} />
          <span className="text-sm hidden lg:inline">Settings</span>
        </button>

        {/* Divider */}
        <div className="w-px h-8 bg-ybh-text-muted/20" />

        {/* Logout button */}
        <button
          onClick={handleLogout}
          className="group flex shrink-0 items-center gap-2 whitespace-nowrap px-3 py-2 rounded-lg text-ybh-text-muted hover:bg-ybh-error/10 hover:text-ybh-error transition-colors duration-200"
          aria-label="Logout"
        >
          <LogOut size={18} />
          <span className="text-sm hidden lg:inline">Sign out</span>
        </button>
      </div>
    </header>
  );
}
